import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home/index"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("@/views/News/index"),
  },
  {
    path: "/news/detail",
    name: "NewsDetail",
    component: () => import("@/views/News/Detail/index"),
  },
  {
    path: "/course_info",
    name: "CourseInfo",
    component: () => import("@/views/CourseInfo/index"),
  },
  {
    path: "/locations",
    name: "Locations",
    component: () => import("@/views/Locations/index"),
  },
  {
    path: "/race_course_info",
    name: "RaceCourseInfo",
    component: () => import("@/views/CourseInfo/index"),
  },
  {
    path: "/race_locations",
    name: "RaceLocations",
    component: () => import("@/views/Locations/index"),
  },
  {
    path: "/training_events",
    name: "TrainingEvents",
    component: () => import("@/views/TrainingEvents/index"),
  },
  {
    path: "/announcements",
    name: "Announcements",
    component: () => import("@/views/Announcements/index"),
  },
  {
    path: "/games",
    name: "Games",
    component: () => import("@/views/Games/index"),
  },
  {
    path: "/locations/court",
    name: "Court",
    component: () => import("@/views/Locations/Court/index"),
  },
  {
    path: "/coaches",
    name: "Coaches",
    component: () => import("@/views/Coaches/index"),
  },
  {
    path: "/coaches/detail",
    name: "CoachesDetail",
    component: () => import("@/views/Coaches/detail/index"),
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import("@/views/Contacts/index"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/Register/index"),
  },
  {
    path: "/register/verify",
    name: "Verify",
    component: () => import("@/views/Register/Verify/index"),
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    component: () => import("@/views/Register/ResetPassword/index"),
  },
  {
    path: "/course_intro",
    name: "CourseIntro",
    component: () => import("@/views/CourseIntro/index"),
  },
  {
    path: "/course_intro/detail",
    name: "CourseIntroDetail",
    component: () => import("@/views/CourseIntro/Detail/index"),
  },
  {
    path: "/enroll",
    name: "Enroll",
    component: () => import("@/views/Enroll/index"),
  },
  {
    path: "/enroll/info",
    name: "EnrollInfo",
    component: () => import("@/views/Enroll/Info/index"),
  },
  {
    path: "/anotherInfo",
    name: "InfoByQRCode",
    component: () => import("@/views/Enroll/InfoByQRCode/index"),
  },
  {
    path: "/enroll/standard",
    name: "EnrollStandard",
    component: () => import("@/views/Enroll/Standard/index"),
  },
  {
    path: "/enroll/complete",
    name: "EnrollComplete",
    component: () => import("@/views/Enroll/Complete/index"),
  },
  {
    path: "/membercenter",
    name: "MemberCenter",
    component: () => import("@/views/MemberCenter/index"),
  },
  {
    path: "/membercenter/orderdetail",
    name: "OrderDetail",
    component: () => import("@/views/MemberCenter/OrderDetail/index"),
  },
  {
    path: "/membercenter/memberedit",
    name: "MemberEdit",
    component: () => import("@/views/MemberCenter/MemberEdit/index"),
  },
];

const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });

const router = createRouter();

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
